<script>
export default {
  name: "Copyright",
  props: {
    isBackgroundWhite: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <div class="copyright">
    <img src="../../assets/images/logo.png" />
    <span
      class="text"
      :style="{ color: isBackgroundWhite ? '#00000' : '#9baad4' }"
      >Copyright © 深圳市振瀚信息技术有限公司
    </span>
  </div>
</template>

<style lang="scss" scoped>
.copyright {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  img {
    width: 40px;
    height: 20px;
  }
  .text {
    margin-left: 8px;
    height: 40px;
    line-height: 40px;
    font-weight: bolder;
    font-size: 12px;
  }
}
</style>
